import type { CompetitorReport, CompetitorSource } from '../../api/types'
import { formatCount } from '../../lib/format'
import { AppCell } from '../AppCell'

export const SOURCE_LABELS: Record<CompetitorSource, string> = {
	claude: 'Claude',
	openai: 'ChatGPT',
	keywords: 'Keywords',
}

/** A finished report's competitors, strongest first, with which source named each and why. */
export function CompetitorTable({ report }: { report: CompetitorReport }) {
	if (report.competitors.length === 0) return <div className="empty">No competitors found.</div>
	return (
		<div className="table-scroll">
			<table>
				<thead>
					<tr>
						<th>App</th>
						<th className="num">Rating</th>
						<th>Price</th>
						<th>Named by</th>
						<th>Why</th>
					</tr>
				</thead>
				<tbody>
					{report.competitors.map((c) => (
						<tr key={c.appId}>
							<td style={{ maxWidth: 0, width: '35%' }}>
								<AppCell app={{ id: c.appId, name: c.name, developerName: c.developerName, iconUrl: c.iconUrl }} />
							</td>
							<td className="num small">
								{c.rating === null ? '—' : `${c.rating.toFixed(1)} ★`}
								<div className="muted">{formatCount(c.ratingCount)}</div>
							</td>
							<td className="small">{c.price ?? '—'}</td>
							<td>
								{c.sources.map((s) => (
									<span key={s} className="badge">
										{SOURCE_LABELS[s]}
									</span>
								))}
							</td>
							<td className="small muted">
								{c.keywordHits.length
									? c.keywordHits.map((h) => `${h.term} #${h.rank}`).join(', ')
									: (c.reasons[0] ?? '')}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
